import React from 'react';
import { Form } from 'react-bootstrap';

const TOE_LABELS = {
  direct: 'Direct',
  secondary: 'Secondary',
  aggravation: 'Aggravation',
  presumptive: 'Presumptive',
};

const buildToeLabel = (toe) => {
  return TOE_LABELS[toe.toeType] || toe.toeType || 'TOE';
};

const ToeSelector = ({ value, options, onChange, disabled }) => {
  return (
    <Form.Select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    >
      <option value="">Select Theory of Entitlement</option>
      {(options || []).map((toe) => (
        <option key={toe.toeId} value={toe.toeId}>
          {buildToeLabel(toe)}
        </option>
      ))}
    </Form.Select>
  );
};

export default ToeSelector;

